<template>
  <div class="floating-menu" :class="{ open: isOpen }">
    <button type="button" class="ft-item" @click="navigateTo('ss-chat-conference')">
      <span>{{ t('label_conference') }}</span>
    </button>
    <button type="button" class="ft-item" @click="navigateTo('ss-chat-meeting')">
      <span>{{ t('label_meeting') }}</span>
    </button>
    <button type="button" class="ft-item" @click="navigateTo('ss-chat-audience')">
      <span> {{ t('label_audience') }}</span>
    </button>
    <button type="button" class="ft-item" @click="navigateTo('ss-chat-general')">
      <span>{{ t('label_general') }}</span>
    </button>
    <button type="button" class="ft-item" @click="navigateTo('ss-chat-single')">
      <span>{{ t('label_single') }}</span>
    </button>
  </div>
</template>
<script setup lang="ts">
import { ref, onMounted, watch } from 'vue';

const router = useRouter();

const { t } = useI18n();

const props = defineProps<{
  isClosing: boolean;
}>();

const isOpen = ref(false);

const navigateTo = (name: string) => {
  router.push({ name });
};

onMounted(() => {
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      isOpen.value = true;
    });
  });
});

// ✅ isClosing이 true가 되면 open 클래스 제거 → transition 시작
watch(
  () => props.isClosing,
  (val) => {
    if (val) isOpen.value = false;
  }
);
</script>
<style scoped lang="scss">
.floating-menu {
  position: absolute;
  bottom: 100%;
  display: flex;
  flex-direction: column;
  gap: $size-xs;
  right: 0;
  padding-bottom: $size-s;
  z-index: 100;
  .ft-item {
    display: block;
    padding: 8px 16px;
    min-width: 80px;
    width: 100%;
    border-radius: 100px;
    background: #fff;
    border: 1px solid $color-gray-40;
    font-size: $font-size-psmall;
    opacity: 0;
    transform: translateX(60px);
    transition:
      opacity 0.4s,
      transform 0.4s !important;
    &:hover {
      background: $color-navy-100;
      border: 1px solid transparent;
      color: #fff;
    }
  }
  &.open {
    .ft-item {
      opacity: 1;
      transform: translateX(0);
      &:nth-child(2) {
        transition-delay: 0.1s !important;
      }
      &:nth-child(3) {
        transition-delay: 0.2s !important;
      }
      &:nth-child(4) {
        transition-delay: 0.3s !important;
      }
      &:nth-child(5) {
        transition-delay: 0.4s !important;
      }
    }
  }
}
</style>
